import {SET_TITLE} from "../actionTypes";

export function setTitle(title) {
  return {
    type: SET_TITLE,
    title: title
  }
}

export function boundSetTitle(title) {
  return dispatch => {
    dispatch(setTitle(title));
  }
}


// WEBPACK FOOTER //
// ./src/state/actions/app.js